import { Text } from '@oneaudi/unified-web-components';
import type { FC } from 'react';
import React, { useContext } from 'react';
import styled from 'styled-components';
import {
  SYS_SPACE_RELATIVE_BP_XS_LG,
  SYS_SPACE_RELATIVE_BP_XS_MD,
} from '@oneaudi/unified-web-common';
import { Icon } from '@oneaudi/unified-web-alpha-components';
import { UniversalStateContext } from '../context/UniversalStateContext';

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: top;
  grid-template-columns: auto 1fr;
  margin-block-start: ${SYS_SPACE_RELATIVE_BP_XS_MD};
  margin-block-end: ${SYS_SPACE_RELATIVE_BP_XS_LG};
  gap: 6px;
  svg {
    padding-top: 2px;
  }
`;
const StyledIcon = styled(Icon)`
  color: ${process.env.IS_LEGACY ? 'black' : 'white'};
`;

export const MoreOptionsDisclaimer: FC = () => {
  const { i18nTexts } = useContext(UniversalStateContext)!;

  return (
    <Container>
      <StyledIcon name="info-circle" size="xs" />
      <Text variant={{ order: process.env.IS_LEGACY ? '2' : '3', style: 'normal' }} tag="span">
        {i18nTexts.moreColorsAndRims}
      </Text>
    </Container>
  );
};
